import React, { memo } from 'react'
import { Avatar } from 'transfix-ui/components/Avatar'
import { makeStyles } from 'transfix-ui/core/styles'

const useOptionAvatarStyles = makeStyles(theme => ({
  root: {
    flex: '0 0 auto',
    paddingRight: theme.spacing(1),
  },
  avatar: {
    boxShadow: 'none',
  },
}))

interface IOptionAvatarProps {
  text?: string
}

export const OptionAvatar = memo<IOptionAvatarProps>(({ text = '' }) => {
  const classes = useOptionAvatarStyles()
  return (
    <div className={classes.root}>
      <Avatar name={text} size='xsmall' hideTooltip className={classes.avatar} />
    </div>
  )
})
